/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/aces_chap_waitlist_enroll
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesChapWaitlistEnrollUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_chap_waitlist_enroll`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESEnrollChapWaitlistDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Gets ACESChapWaitlistCheckRespDlts from api:
 * /v1/ua/aces_chap_waitlist_applied
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchAcesChapWaitlistAppliedUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_chap_waitlist_applied`,
    models.ACESChapWaitlistCheckRespDlts
  );
};

/**
 * Gets ACESWaitlistFundAvailableResp from api:
 * /v1/ua/aces_chap_waitlist_fund_available
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchAcesChapWaitlistFundAvailableUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_chap_waitlist_fund_available`,
    models.ACESWaitlistFundAvailableResp
  );
};

/**
 * Post request to path:
 * /v1/ua/aces_chap_waitlist_submit_form
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesChapWaitlistSubmitFormUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_chap_waitlist_submit_form`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESWaitlistFormResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

export {
  postAcesChapWaitlistEnrollUtil,
  fetchAcesChapWaitlistAppliedUtil,
  fetchAcesChapWaitlistFundAvailableUtil,
  postAcesChapWaitlistSubmitFormUtil,
};
